<script setup lang="ts">
import { computed } from 'vue';
import { Separator } from 'reka-ui';
import { cn } from '@/lib/utils';

interface Props {
  class?: string;
  orientation?: 'horizontal' | 'vertical';
  decorative?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  orientation: 'horizontal',
  decorative: true,
});

const separatorClass = computed(() =>
  cn('shrink-0 bg-border', props.orientation === 'horizontal' ? 'h-[1px] w-full' : 'h-full w-[1px]', props.class),
);
</script>

<template>
  <Separator :orientation="orientation" :decorative="decorative" :class="separatorClass" v-bind="$attrs" />
</template>
